import { render } from "./Terms.vue?vue&type=template&id=75a27c78"
import script from "./Terms.vue?vue&type=script&lang=ts"
export * from "./Terms.vue?vue&type=script&lang=ts"
script.render = render

export default script